import Preloader from "./components/Preloader";
import Header from "./components/Header";
import Hero from "./components/Hero";
import Countdown from "./components/Countdown";
import Couple from "./components/Couple";
import WelcomeArea from "./components/WelcomeArea";
import Story from "components/Story";
import People from "components/People";
import Event from "components/Event";
import Gallery from "components/Gallery";
import Contact from "components/Contact";
import Gift from "components/Gift";
import Footer from "components/Footer";

const App = () => {
	return (
		<>
			<Preloader />

			<Header />

			<Hero />

			<Countdown />

			<Couple />

			<WelcomeArea />

			<Story />

			<People />

			<Event />

			<Gallery />

			<Contact />

			<Gift />

			<Footer />
		</>
	);
};

export default App;
